export {default} from './settings.vue'